// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29s3s","comment":"styles_comment__6JLax"};